import clsx from 'clsx';
import { Link } from 'react-router';
import styles from './Button.module.scss';
import Loader from './Loader';

type ButtonProps = {
    to?: string;
    size?: 's' | 'm' | 'l' | 'xl' | 'xxl';
    theme?: 'link' | 'blank' | 'plain' | 'primary';
    shape?: 'default' | 'square';
    align?: 'center' | 'left' | 'right';
    loading?: boolean;
    disabled?: boolean;
    keepDropdownOpen?: boolean;
    onClick?: any;
    style?: React.CSSProperties;
    children: React.ReactNode | React.ReactNode[];
};

export const Button = ({
    to,
    size,
    theme,
    shape = 'default',
    align = 'center',
    loading = false,
    disabled = false,
    keepDropdownOpen = false,
    style,
    onClick,
    children,
}: ButtonProps): JSX.Element => {
    const wrapClsx = clsx(
        styles.wrap,
        styles[shape],
        styles[align],
        styles[size ? size : 'l'],
        styles[theme ? theme : 'blank'],
        {
            [styles.loading]: loading,
            [styles.disabled]: disabled,
        }
    );
    const childrenClsx = clsx(styles.children, {
        [styles.loading]: loading,
    });
    const loaderClsx = clsx(styles.loader, { [styles.loading]: loading });
    const handleOnClick = () => {
        if (!disabled && !loading && onClick) {
            onClick();
        }
    };

    const content = (
        <p className={childrenClsx} style={style}>
            {children}
            <span className={loaderClsx}>
                <Loader />
            </span>
        </p>
    );

    if (to) {
        return (
            <Link to={to} className={wrapClsx}>
                {content}
            </Link>
        );
    }

    return (
        <button
            className={wrapClsx}
            disabled={disabled}
            onClick={handleOnClick}
            data-keep-open={keepDropdownOpen || undefined}
        >
            {content}
        </button>
    );
};

export default Button;
